"use client";
import PageTitle from "@/components/shared/page-title/PageTitle";
import { Accordion } from "@/components/shared/accordion/Accordion";
import { useEffect, useState } from "react";
import { commonFetch } from "@/utils/commonFetch";
import { IEssays } from "@/interface/essays";
import { IAccordion } from "@/interface/common";
export default function Essays() {
  const [essaysData, setEssaysData] = useState<IEssays | null>(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await commonFetch.get("essays-page");
        setEssaysData(response);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      <div className="xl:mt-48 md:mt-32 mt-24 grid grid-cols-12">
        <div className="col-span-10 col-start-1 md:col-start-2 xl:mb-16">
          <PageTitle
            title={essaysData?.pagetitle.title}
            description={essaysData?.pagetitle.description}
            cls={"w-[120%]"}
          ></PageTitle>
        </div>
        <div className="md:p-8 col-span-12 ml-[18px] mr-[18px] mb-10 lg:mb-0">
          {essaysData?.essays.map((essay: IAccordion, index: any) => (
            <div key={index} className="xl:mb-2 mb-6">
              <Accordion
                isFullBorder={true}
                isPDF={!!essay?.pdf?.url}
                title={essay?.title}
                subtitle1={essay?.subtitle1}
                subtitle2={essay?.subtitle2}
                description={essay?.description}
                downloadLink={essay?.pdf?.url}
              ></Accordion>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
